const ArrowSelect = ({ className }: { className?: string }) => {
  return (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0)">
        <mask id="mask0" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="-4" y="-4" width="24" height="24">
          <rect x="-4" y="20" width="24" height="24" transform="rotate(-90 -4 20)" fill="#D9D9D9" />
        </mask>
        <g mask="url(#mask0)">
          <path
            d="M8.00533 9.69312L13.2462 4.31746C13.4525 4.10582 13.6932 4.00353 13.9683 4.01058C14.2434 4.01764 14.4842 4.12698 14.6905 4.33862C14.8968 4.55026 15 4.79718 15 5.07936C15 5.36155 14.8968 5.60847 14.6905 5.82011L9.18142 11.4921C9.01636 11.6614 8.83066 11.7884 8.62432 11.873C8.41799 11.9577 8.21166 12 8.00533 12C7.79899 12 7.59266 11.9577 7.38633 11.873C7.18 11.7884 6.9943 11.6614 6.82923 11.4921L1.29952 5.82011C1.09318 5.60847 0.993455 5.35802 1.00033 5.06878C1.00721 4.77954 1.11382 4.5291 1.32015 4.31746C1.52648 4.10582 1.7672 4 2.04231 4C2.31742 4 2.55814 4.10582 2.76448 4.31746L8.00533 9.69312Z"
            fill="#C0C0C0"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0">
          <rect y="16" width="16" height="16" rx="3" transform="rotate(-90 0 16)" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ArrowSelect;
